import {
  SALES_LOADING,
  GET_SALES,
  GET_SALES_ONE,
  GET_SALES_SUCCESS,
  GET_SALES_FAIL,
  ADD_SALES_SUCCESS,
  ADD_SALES_FAIL,
  DELETE_SALES_SUCCESS,
  DELETE_SALES_FAIL,
  UPDATE_SALES_SUCCESS,
  UPDATE_SALES_FAIL,
  SALES_RESET
} from "./actionType";

const INIT_STATE = {
  saless: [],
  salesOne: {},
  salesAdded: {},
  error: {},
};

const Sales = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SALES_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SALES:
          return {
            ...state,
            saless: action.payload.data,
            isSalesCreated: false,
            isSalesSuccess: true,
            loading: false,
          };

        case GET_SALES_ONE:
          return {
            ...state,
            salesOne: action.payload.data,
            isSalesSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_SALES_FAIL:
      switch (action.payload.actionType) {
        case GET_SALES_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isSalesCreated: false,
            isSalesSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_SALES: {
      return {
        ...state,
        isSalesCreated: false,
        loading: true,
      };
    }

    case GET_SALES_ONE: {
      return {
        ...state,
        salesOne: action.payload.data,
        isSalesCreated: false,
        loading: true,
      };
    }

    case SALES_LOADING: {
      return {
        ...state,
        isSalesCreated: false,
        loading: true,
      };
    }

    case ADD_SALES_SUCCESS:
      return {
        ...state,
        isSalesCreated: true,
        loading: false,
        saless: [action.payload.data, ...state.saless],
        salesAdded: action.payload.data
      };

    case ADD_SALES_FAIL:
      return {
        ...state,
        loading: false,
        isSalesCreated: false,
        error: action.payload,
      };

    case DELETE_SALES_SUCCESS:
      return {
        ...state,
        loading: false,
        saless: state.saless.filter(
          saless => saless.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_SALES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_SALES_SUCCESS:
      return {
        ...state,
        loading: false,
        isSalesCreated: true,
        saless: state.saless.map(saless =>
          saless.id.toString() === action.payload.data.id.toString() ? { ...saless, ...action.payload.data } : saless
        ),
        salesAdded: action.payload.data
      };

    case UPDATE_SALES_FAIL:
      return {
        ...state,
        loading: false,
        isSalesCreated: false,
        error: action.payload,
      };

    case SALES_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Sales;